import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {EventCreationMode, HeaderFields} from 'src/modules/event-create/constants';
import {DEPRECATED_INFO} from 'src/modules/event-create/event-create-hovers';
import {HeaderBlock} from 'src/modules/event-create/typedefs';

import {CheckBox} from '@pb/kit-component-checkbox';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';

type Props = {
    mode: EventCreationMode,
    headerValues: HeaderBlock,
    changeRequestId: number | null,
    onChangeCheckboxField: (data: {event: React.SyntheticEvent<HTMLInputElement>, name: string}) => void,
};

export const Deprecated = (props: Props) => {
    const {mode, headerValues, changeRequestId, onChangeCheckboxField} = props;

    return (
        <>
            {mode === EventCreationMode.update && (
                <Group gap="xs" alignItems="center">
                    <CheckBox
                        name={HeaderFields.deprecated}
                        label={<strong>Deprecated</strong>}
                        checked={headerValues.deprecated}
                        onCheckBoxChange={onChangeCheckboxField}
                    />
                    <Dropdown
                        hoverEnabled={true}
                        clickEnabled={false}
                        maxWidth={500}
                        anchor={({anchorRef, getAnchorProps}) => (
                            <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                        )}>
                        {DEPRECATED_INFO}
                    </Dropdown>
                    <EventReviewFeedback
                        changeRequestId={changeRequestId}
                        fieldName={HeaderFields.deprecated}
                    />
                </Group>
            )}
        </>
    );
};
